moduleViewApp.service("NewSeriesService", ['$rootScope', '$filter', 'MySeriesResource', ($rootScope, $filter, MySeriesResource) ->
  $scope = $rootScope.$new()

  #debug
  window.debug = window.debug || {}
  window.debug["NewSeriesService"] = $scope

  _.assignIn $scope,
    title: $filter("translate")("js.module_view.new_series.title")

    module_type: "series"

    path: (version) ->
      Packs.iKnowRoutes.v2_create_series_path

    resource: MySeriesResource

  $scope
])
